// Tiny shared typography helpers for the public legal pages
// (Privacy / Terms / Refund / Contact). Keeps section spacing,
// heading sizes, and bullet styling consistent across all four
// pages without pulling in a heavyweight typography plugin.
//
// LEGAL TEMPLATE NOTICE: This is a business/legal template. Have
// it reviewed by counsel before going to production, and update
// any [bracketed placeholders] (registered office, jurisdiction,
// legal entity name) with real values.

export function LegalSection({ title, children }) {
  return (
    <section className="mt-7">
      <h2 className="text-lg sm:text-xl font-bold text-ink-900 m-0">
        {title}
      </h2>
      <div className="mt-2 text-sm sm:text-[15px] text-ink-700 leading-relaxed space-y-3">
        {children}
      </div>
    </section>
  );
}

export function LegalList({ items }) {
  return (
    <ul className="list-disc pl-5 m-0 space-y-1.5">
      {items.map((it, idx) => (
        <li key={idx}>{it}</li>
      ))}
    </ul>
  );
}

export function LegalDefinitionList({ rows }) {
  return (
    <dl className="space-y-2 m-0">
      {rows.map((r, idx) => (
        <div
          key={idx}
          className="grid grid-cols-1 sm:grid-cols-[140px_minmax(0,1fr)] gap-x-4 gap-y-0.5"
        >
          <dt className="font-semibold text-ink-800">{r.label}</dt>
          <dd className="m-0 text-ink-700">{r.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export function LegalCallout({ tone = 'info', children }) {
  const palette =
    tone === 'warning'
      ? 'border-amber-200 bg-amber-50 text-amber-900'
      : tone === 'success'
      ? 'border-emerald-200 bg-emerald-50 text-emerald-900'
      : 'border-brand-200 bg-brand-50 text-brand-800';
  return (
    <div className={`rounded-lg border px-3 py-2 text-sm ${palette}`}>
      {children}
    </div>
  );
}
